import { render, staticRenderFns } from "./Opcao01.vue?vue&type=template&id=7e75f390&"
import script from "./Opcao01.vue?vue&type=script&lang=js&"
export * from "./Opcao01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports